import React, { useEffect, useState } from 'react';
import './Steps.css';

function FinalStep() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    setTimeout(() => setShow(true), 500);
  }, []);

  return (
    <div className="step-container final-step">
      <div className={`step-content final-content ${show ? 'show' : ''}`}>
        <div className="heart-animation">
          <div className="heart">❤️</div>
        </div>
        <h1 className="final-title">🔓 Access Granted Sai Deepika ❤️</h1>
        <p className="final-text">You're the only admin of my heart. Forever together</p>
        <div className="final-subtitle">
          <p>No password required.</p>
          <p>You already own it.</p>
        </div>
      </div>
    </div>
  );
}

export default FinalStep;